import { render } from "./Location.vue?vue&type=template&id=5c0334b0&scoped=true&ts=true"
import script from "./Location.vue?vue&type=script&lang=ts"
export * from "./Location.vue?vue&type=script&lang=ts"

import "./Location.vue?vue&type=style&index=0&id=5c0334b0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0334b0"]])

export default __exports__